import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import AuthLayout from "../../shared/containers/AuthLayout";
import {deleteAccount, logout} from "../user/actions/userAction";
import * as notificationAction
  from "../../shared/modules/notification/actions/notificationsAction";
import {
  NOTIFICATION_ERROR,
  NOTIFICATION_SUCCESS
} from "../../shared/modules/notification/constants";


class Delete extends React.Component {

  static propTypes = {
    user: PropTypes.object
  };

  delete = () => {
    this.props.dispatch(deleteAccount())
      .then(() => {
        this.props.dispatch(logout());
        this.props.dispatch(
          notificationAction.addNotification(
            __("Your account will be removed shortly."),
            NOTIFICATION_SUCCESS
          )
        );
      })
      .catch(() => {
        this.props.dispatch(
          notificationAction.addNotification(
            __("There was an error deleting your account, please contact %email%")
              .replace('%email%', 'it@media4care.com'),
            NOTIFICATION_ERROR
          )
        )
      }
    );
  };

  cancel = () => {
    this.props.history.goBack();
  };

  render() {
    return (
      <AuthLayout title={__("Delete my account")}
                  onBackLink={this.props.history.goBack}
                  description={__("Do you really want to delete your account?")}>
        <div id="deleteAccount" className="flexBox direction-column flex">
          <div className="deletionInfo">
            <p>{__("Your account")}: {this.props.user.email}</p>
            <p className="warning">
              {__("Attention: This process can not be undone and Your pictures and messages will be permanently deleted.")}
            </p>
          </div>
          <button className="buttonError" onClick={this.delete}>
            {__("Delete account")}
          </button>
          <button className="buttonPrimary"
                  onClick={this.cancel}>{__("Abort")}
          </button>
        </div>
      </AuthLayout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user
  };
};

export default connect(mapStateToProps)(Delete);
